import { AiService } from './../../../../../service/ai.service';
import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddPinComponent } from '../../../../../components-track/feedback-card/add-pin/add-pin.component';
import { ResultPreviewComponent } from '../../result-preview/result-preview.component';
import { SnackService } from '../../../../../service/snack.service';
import { TrackService } from '../../../../../service/track.service';

@Component({
  selector: 'app-feedback-pins-dashboard',
  standalone: false,
  templateUrl: './feedback-pins-dashboard.component.html',
  styleUrl: './feedback-pins-dashboard.component.scss'
})
export class FeedbackPinsDashboardComponent implements AfterViewInit {
  // Injections
  readonly dialogRef = inject(MatDialogRef<FeedbackPinsDashboardComponent>);
  readonly dialog = inject(MatDialog);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  trackService = inject(TrackService);
  readonly aiService = inject(AiService);
  readonly router = inject(Router);
  readonly snack = inject(SnackService);
  cd = inject(ChangeDetectorRef);

  // Variables
  loading: boolean = false;
  bmcReady: boolean = true;

  // Onjects
  pins: any[] = [];
  reportResults: any[] = [];
  agentList: any[] = [];



  async ngAfterViewInit(): Promise<void> {
    this.agentList = await this.aiService.getAgentsList();
    this.orderPins();
    this.cd.detectChanges();
    this.trackService.initialTrackDataLoad(this.data.trackId, this.data.roundId);

  }
  async generateBmc() {
    /*
    <USER CONTENT>
    <elevator pitch>
    <market report>
    <competitor report>
    <user research report>
    <startup mentor report>
   */
    console.log(this.data.results);
    let allResults: any[] = [];
    let reports: any[] = []

    for await (const result of this.data.results) {
      if (result.streamId == "J1S-8At2nL")
        allResults.push(...result.stepResults);

      if (result.streamId == "export_reports")
        reports.push(...result.stepResults);
    }


    let mainPersona = await allResults.find((r: any) => r.stepId == "Ci6Ju_grd");
    let basicIdea = await allResults.find((r: any) => r.stepId === "MMUT2vQla");
    let insightMapping = await allResults.find((r) => r.stepId === "jKHo2wIzi");

    let userInput = `<USER CONTENT Start>
    <BASIC IDEA>
    ${JSON.stringify(basicIdea.result)}

    <MAIN PERSONA>
    ${JSON.stringify(mainPersona.result)}

    <USER INSIGHT MAPPING>
    ${JSON.stringify(insightMapping.result.persona_extension)}

    `

    for await (const report of reports) {
      userInput += `<${report.stepId.replace('_', ' ')}>
      ${JSON.stringify(report.result)}

      `;
    }

    // console.log(userInput);

    userInput += `
    <USER CONTENT End>
    `;



    let name = "BMC - Report";
    this.loading = true;
    let bmcResult = await this.aiService.getAiStandaloneResponse("GENERATE_BMC", userInput, this.data.roundId)
    console.log("BMC_RESULT", bmcResult.promptResult);

    bmcResult.promptResult[0].name = name;

    // console.log("fileResult", fileResult);
    this.loading = false;

    // Save BMC-Report Data to Step: Reports
    await this.trackService.addStepResult(this.data.roundId, "export_reports", "REPORT_BMC", bmcResult.promptResult[0], "BMC");


    // this.dialog.open(ResultPreviewComponent, { data: bmcResult.promptResult[0] });
    this.openPdfPreview(bmcResult.promptResult[0]);


  }
  async checkReports() {
    let reports = this.data.results.filter((r: any) => r.streamId == "export_reports");
    let agents = this.agentList;
    let missingReport = false;
    for await (let agent of agents) {
      let reportId = agent.reportId;
      let existsReport = await reports.find((r: any) => r.stepId === reportId);
      if (!existsReport) {
        missingReport = true;
      }
    }

    this.bmcReady = !missingReport;
  }

  async orderPins() {
    this.pins = [];
    if (this.data?.feedbackCardResult?.pins?.length == 0) return;

    for await (let agent of this.agentList) {
      let agentPins = await this.data.feedbackCardResult.pins?.filter((pin: any) => pin.agentId === agent.id);

      if (agentPins && agentPins.length > 0 && agent.addAgentNameOnReportPins === true) {
        agentPins.forEach((p: any) => {
          // Process each pin as needed
          p.agentName = agent.name
        });
      }
      this.pins.push({
        "agentId": agent.id,
        "agentName": agent.name,
        "reportId": agent.reportId,
        "pins": agentPins
      });
    }

  }
  async gotoAgent(agentId: string) {
    // console.log(this.data); return;

    this.router.navigate(['new-track-run', this.data.trackId], {
      queryParams: {
        streamId: "4dXLpB4Ll",
        stepId: "k9G9Fv8w6",
        roundId: this.data.roundId,
        agentId: agentId
      },
      replaceUrl: true
    });
    this.dialogRef.close();
  }
  async miroExport() {
    this.loading = true;
    await this.aiService.aiMiroExport(this.pins);
    this.loading = false;
  }
  async generateReport(reportId: string) {

    console.log("Generating report for reportId:", reportId);

    // Get agent by reportId
    let agent = await this.agentList.find((a: any) => a.reportId === reportId);
    let agentId = agent ? agent.id : "";

    // check if Report exists && NO ChangeEvent exists
    let changeEventsExists = await this.data.feedbackCardResult.changedEvents.filter((e: any) => e.agentId === agentId);
    let report = await this.data.results.find((r: any) => r.streamId === "export_reports");
    let allResults = []
    for await (let res of this.data.results) {
      allResults.push(...res.stepResults)
    }
    let con = ""
    let basicIdea = allResults.find((r) => r.stepId === "MMUT2vQla")
    let userTinder = allResults.find((r) => r.stepId === "Ci6Ju_grd")
    let insightMapping = allResults.find((r) => r.stepId === "jKHo2wIzi")

    con = `<BASIC IDEA>
    ${JSON.stringify(basicIdea.result)}
    <MAIN PERSONA>
    ${JSON.stringify(userTinder.result)}
    <USER INSIGHT MAPPING>
    ${JSON.stringify(insightMapping.result.persona_extension)}
    `


    let reportExists;
    if (report) {
      reportExists = await report.stepResults.find((r: any) => r.stepId === reportId);
    }

    console.log('Report exists:', reportExists, 'Change events exist:', changeEventsExists);

    if (changeEventsExists.length === 0 && reportExists) {
      this.openPdfPreview(reportExists.result);
      return;
    }


    let content: any[] = []
    for await (let agent of this.pins) {
      if (agent.reportId == reportId) {
        content = [...content, ...agent.pins]
      }
    }

    con += '<PINS>';
    let counter = 1;
    for await (let pin of content) {
      con += `
      <PIN ${counter}>
      topic: ${pin.topic}
      content: ${pin.content}
      prio: ${pin.prio}
      agentName: ${pin.agentName}`;
      counter++;
    }


    con += `
    <USER CONTENT End>
    `;

    this.loading = true;
    console.log("Content", con);

    let result: any = await this.aiService.aiGeneratedReport(con, reportId)
    console.log("Result", result);

    this.loading = false;
    if (result.promptResult) {

      // Save Report Data to Step: Reports
      await this.trackService.addStepResult(this.data.roundId, "export_reports", reportId, result.promptResult, "Report " + agent.name);

      // Remove Chenge-Elements for Report
      this.data.feedbackCardResult.changedEvents = await this.data.feedbackCardResult.changedEvents.filter((e: any) => e.agentId !== agentId);

      // Update feedback card results
      await this.trackService.addStepResult(this.data.roundId, "4dXLpB4Ll", "k9G9Fv8w6", this.data.feedbackCardResult, "Feeback Card");

      this.openPdfPreview(result.promptResult);

    } else {
      this.snack.error({ error: { headline: "AI Error", text: "An error occurred while generating the report." } })
    }

  }

  async openPdfPreview(data: any) {
    this.dialog.open(ResultPreviewComponent, {
      panelClass: "feed-back-card",
      autoFocus: false,
      data: data
    })
  }

  async saveAfterChanges() {

    await this.trackService.addStepResult(this.data.roundId, this.data.streamId, this.data.stepId, this.data.feedbackCardResult, "Feedback Card");
    this.orderPins();
  }
  async editPin(pin: any) {
    const dialogRef = this.dialog.open(AddPinComponent, {
      data: { edit: true, topic: pin.topic, content: pin.content }
    });

    await dialogRef.afterClosed().subscribe(async (data) => {

      console.log("Pin edit dialog closed.", data);


      if (data) {
        for await (let p of this.data.feedbackCardResult.pins) {
          if (p == pin) {
            pin.topic = data.topic;
            pin.content = data.content;
            data.dateEdited = new Date().getTime();
            data.prio = false;
            this.addChangeEvent(pin.agentId, "edited");
            return;
          }
        }
      }

    });
  }
  async deletePin(pin: any) {
    this.data.feedbackCardResult.pins = await this.data.feedbackCardResult.pins.filter((p: any) => p !== pin);
    this.addChangeEvent(pin.agentId, "deleted")
  }
  async priorizePin(pin: any) {
    for await (let p of this.data.feedbackCardResult.pins) {
      if (p == pin) {
        p.prio = !p.prio;
        this.addChangeEvent(pin.agentId, "priorise")
        return;
      }
    }
  }
  async addChangeEvent(agentId: string, type: string) {
    let exists = await this.data.feedbackCardResult.changedEvents.find((event: any) => event.agentId === agentId && event.type === type);

    if (!exists) {
      this.data.feedbackCardResult.changedEvents.push({ agentId, type });
    }
    this.saveAfterChanges();
  }
  close() {
    this.dialogRef.close();
  }
}
